import { render, staticRenderFns } from "./RegionalSOS.vue?vue&type=template&id=560751c6&scoped=true&"
import script from "./RegionalSOS.vue?vue&type=script&lang=js&"
export * from "./RegionalSOS.vue?vue&type=script&lang=js&"
import style0 from "./RegionalSOS.vue?vue&type=style&index=0&id=560751c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560751c6",
  null
  
)

export default component.exports